<template>
  <div class="fee-receipt-table mx-8 my-4">
    <table :style="`width: 100%;background-color:white;font-weight:${ receipt.settings.font_weight }`" class="table border-bottom-none" v-if="receipt">
      <tbody>
        <tr style="height: 30px;">
          <td
            class="border-right-none"
            style="height: 44px;padding-left:20px;text-align:left;"
            colspan="2"
            rowspan="2"
          >
            <img :src="currentInstitution.logo" :height="`${receipt.settings.logo_size ? receipt.settings.logo_size : '140' }px`" />
          </td>
          <td class="border-bottom-none border-sides-none" colspan="8">
              <img v-if="receipt.settings.font_image" :src="receipt.settings.font_image" style="max-height:48px;max-width:100%;padding-top:8px;"/> 
             <span v-else class="bold" style="height: 22px; font-size: 24px;">{{ currentInstitution.name }}</span>
            <div class="html-header ql-editor">
              <div v-html="receipt.settings.header_content" style="max-width:100%" class="py-0"></div>
            </div>
          </td>
          <td class="border-left-none" style="height: 60px;" colspan="2" rowspan="2">{{copyName || "PARENT COPY"}}</td>
        </tr>
        <tr style="height: 22px;">
          <td class="border-top-none border-sides-none" colspan="6"><b>Fee Receipt ({{ receipt.settings.show_academic_year? receipt.session.title : Helper.getFiscalYear(new Date(receipt.payment_date)) }})</b></td>
        </tr>
      </tbody>
    </table>
    <table :style="`width: 100%;background-color:white;font-weight:${ receipt.settings.font_weight }`" class="table border-bottom-none" v-if="receipt">
      <tbody>

        <tr style="height: 22px;">
          <td class="border-none" style="height: 30px;" width="20%">Student Name :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            width="40%"
          >{{ receipt.fee_account.student.full_name }}</td>
          <!-- <td class="border-none"></td> -->
          <td class="border-none" style="height: 30px;" width="20%">Receipt Number :</td>
          
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            width="20%"
          >{{ receipt.receipt_number }}</td>
        </tr>
        <tr style="height: 22px;">
          <td class="border-none" style="height: 30px;" width="20%">GR Number :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            width="40%"
          >{{ receipt.fee_account.student.gr_no }}</td>
          <!-- <td class="border-none"></td> -->
          <td class="border-none" style="height: 30px;" width="20%">Payment Date :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            width="20%"
          >{{ moment(receipt.payment_date).format("DD-MMM-YYYY") }}</td>
          
        </tr>
        <tr style="height: 22px;">
          <td class="border-none" style="height: 30px;" width="20%">Contact Number :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            width="40%"
          >{{ receipt.fee_account.student.phone }}</td>
          <!-- <td class="border-none"></td> -->
        <td class="border-none" style="height: 30px;" width="20%">Class :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            width="20%"
          >{{ receipt.fee_account.room.sections }}</td>

        </tr>
      </tbody>
    </table>
      <table :style="`width: 100%;background-color:white;font-weight:${ receipt.settings.font_weight }`" class="table border-edges-none" v-if="receipt">
        <tbody>
        <tr style="height: 30px;">
          <th style="height: 30px;" width="10%">Sr. No</th>
          <th style="height: 30px;">Particulars</th>
          <th style="height: 30px;">Instalment</th>
          <th style="height: 30px;" width="20%" v-if="receipt.settings.show_due_amount">Due Amount</th>
          <th style="height: 30px;" width="20%">Amount Paid</th>
        </tr>
        <tr
          style="height: 30px;"
          v-for="(money_transaction, index) in getMoneyTransactions()"
          :key="money_transaction.id"
        >
          <td style="height: 30px;"
          :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''" width="10%">{{ index + 1}}
          </td>

          <td
            style="height: 30px;"
            :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''"  
          >{{ money_transaction.particular_title }}<span v-if="receipt.session && serverActiveSession && receipt.session.id != serverActiveSession.id"> ({{receipt.session.title}})</span></td>

          <td
            style="height: 30px;"
            :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''"
          >{{ money_transaction.schedule_instalment_title }}</td>

          <td
            style="height: 30px;"
            :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''"
            width="20%"
            v-if="receipt.settings.show_due_amount"
          >{{ currencyFormat(Number(money_transaction.due_amount) || 0) }}<span v-if="money_transaction.concession > 0"><b> (-{{currencyFormat(Number(money_transaction.concession) || 0)}})</b></span><span v-if="money_transaction.fine > 0"><b> (+{{currencyFormat(Number(money_transaction.fine) || 0)}})</b></span>
          </td>

          <td
            style="height: 30px;"
            :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''"
            width="20%"
          >{{currencyFormat(parseInt(money_transaction.amount_paid || 0))}}
          </td>
        </tr>
        <tr v-for="r in getExtraRows()" :key="r">
          <td style="height: 30px;" :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''" width="10%"></td>
          <td style="height: 30px;" :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''"></td>
          <td style="height: 30px;" :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''"></td>
          <td style="height: 30px;" :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''" width="20%" v-if="receipt.settings.show_due_amount"></td>
          <td style="height: 30px;" :class=" receipt.settings.hide_instalment_edges ? 'border-edges-none': ''" width="20%"></td>
        </tr>
      </tbody>
    </table>
    <table :style="`width: 100%;background-color:white;font-weight:${ receipt.settings.font_weight }`" class="table border-edges-none" v-if="receipt">
      <tbody>
        <tr style="height: 30px;" v-if="receipt.settings.show_concession || Number(receipt.total_concession) > 0">
          <td style="height: 30px;" width="10%">&nbsp;</td>
          <td style="height: 30px;" class="bold" width="70%">{{ receipt.fee_account.category.concession_is_scholarship ? 'Scholarship' : 'Concession'}}</td>
          <td
            style="height: 30px;"
            class="bold"
            width="20%"
          >{{ currencyFormat(receipt.total_concession) }}</td>
        </tr>
        <tr v-if="receipt.total_fine > 0" style="height: 30px;">
          <td style="height: 30px;" width="10%">&nbsp;</td>
          <td style="height: 30px;" class="bold" width="70%">Fine</td>
          <td
            style="height: 30px;"
            class="bold"
            width="20%"
          >{{ currencyFormat(receipt.total_fine) }}</td>
        </tr>
        <tr style="height: 30px;">
          <td style="height: 30px;" width="10%">&nbsp;</td>
          <td style="height: 30px;" class="bold" width="70%">Total Paid</td>
          <td
            class="bold"
            style="height: 30px;"
            width="20%"
          >{{ currencyFormat(receipt.total_amount_paid) }}</td>
        </tr>
        <tr v-if="receipt.settings.show_total_balance" style="height: 30px;">
          <td style="height: 30px;" width="10%">&nbsp;</td>
          <td style="height: 30px;" class="bold" width="70%">Total Balance Amount</td>
          <td
            class="bold"
            style="height: 30px;"
            width="20%"
          >{{ currencyFormat(receipt.total_balance_post_payment) }}</td>
        </tr>
      </tbody>
    </table>
    <table :style="`width: 100%;background-color:white;font-weight:${ receipt.settings.font_weight }`" class="table border-edges-none" v-if="receipt">
      <tbody>
        <tr style="height: 30px;">
          <td width="20%" class="bold">Amount in words</td>
          <td width="80%" class="text-left px-4"><b>{{ inWords(parseInt(receipt.total_amount_paid)).toUpperCase() }}</b></td>
        </tr>
      </tbody>
    </table>
    <table :style="`width: 100%;background-color:white;font-weight:${ receipt.settings.font_weight }`" class="table border-edges-none" v-if="receipt">
      <tbody>
        <tr style="height: 30px;">
          <td width="20%" class="bold">Mode</td>
          <td width="20%">{{ receipt.mode }}</td>
          <td width="10%" class="bold">Remarks</td>
          <td class="text-left px-4">{{ receipt.remarks || "-"  }}</td>
        </tr>
      </tbody>
    </table>
    <table :style="`width: 100%;background-color:white;font-weight:${ receipt.settings.font_weight }`" class="table border-edges-none" v-if="receipt">
      <tbody>
        <tr style="height: 80px">
          <td width="80%" style="font-size: 14px;" class="text-left px-4">
            <div v-html="receipt.settings.notes" class="py-0">
              
            </div>
          </td>
          <td width="20%" style="vertical-align: bottom;">
            <div>
              <img v-if="receipt.settings.signature" :src="receipt.settings.signature" height="40px" />

            </div>
            <b>Cashier/Manager</b>
          </td>
        </tr>
      </tbody>
    </table>
    <p style="page-break-before: always" v-if="(parseInt($route.params.count) == 2) && (copyName == 'OFFICE COPY')"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Helper from "@utils/misc";
import moment from "moment";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: "FeeReceiptTable",
  props: ["receipt", "copyName"],
  data() {
    return {
      moment: moment,
      Helper: Helper,
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentInstitution",
      "accessToken",
      "isLoading",
      "feeSessionData"
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
    serverActiveSession() {
      return this.feeSessionData.find((s) => s.active);
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    currencyFormat: Helper.currencyFormat,
    inWords: Helper.inWords,
    getExtraRows(){
      let extra_rows = this.receipt.settings.particular_rows - this.receipt.money_transactions.length
      console.log(extra_rows)
      return (extra_rows > 0 ? extra_rows : 0)
    },

    getMoneyTransactions(){
      
      var money_transactions = this.receipt.money_transactions;

      if(this.receipt.settings.hide_zero_amount_money_transactions){ 
        // this.receipt.money_transactions = this.receipt.money_transactions.filter(transaction => transaction.get_actual_amount_paid != 0);
        
        money_transactions =  this.receipt.money_transactions.filter(transaction => transaction.get_actual_amount_paid != 0);

      }
      
      if(this.receipt.settings.combine_similar_particulars){
        const mt_particulars = [...new Set(money_transactions.map(transaction => transaction.fit.instalment.particular))];

        // console.log("Unique particulars: ", mt_particulars);
        const unique_particulars = [];

        const map = new Map();
        for (const item of mt_particulars) {
            if(!map.has(item.id)){
                map.set(item.id, true);    // set any value to Map
                unique_particulars.push(item);
            }
        }

        const combined_money_transactions = unique_particulars.map(particular => {
          let particular_money_transcations = money_transactions.filter(transaction => transaction.fit.instalment.particular.id  == particular.id); 


          // particular_money_transcations = [...new Set(particular_money_transcations.map(transaction => transaction.fit.instalment.particular.id))];

          // console.log("Unique particulars: ", particular_money_transcations);

          let combined_transaction = {
             particular_title: particular.title,
             schedule_instalment_title: particular_money_transcations.length > 1 ? `${particular_money_transcations[0].schedule_instalment_title} - ${particular_money_transcations[particular_money_transcations.length - 1].schedule_instalment_title}` : particular_money_transcations[0].schedule_instalment_title, 
             amount_paid: Helper.totalSum(particular_money_transcations, "amount_paid"), 
             fine: Helper.totalSum(particular_money_transcations, "fine"),
             get_actual_amount_paid: Helper.totalSum(particular_money_transcations, "get_actual_amount_paid"),
             concession: Helper.totalSum(particular_money_transcations, "concession"),
             due_amount: Helper.totalSum(particular_money_transcations, "due_amount"),
          }; 

          return combined_transaction;
        });

        // console.log(combined_money_transactions);
        money_transactions = combined_money_transactions; 
      }
    
      return money_transactions; 
    }
  },
};
</script>

<style lang="css" scoped>
.bold {
  font-weight: bold;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
.border-bottom-none {
  border-bottom: none;
}
.border-top-none {
  border-top: none;
}
.border-edges-none {
  border-top: none;
  border-bottom: none;
}
.border-left-none {
  border-left: none;
}
.border-right-none {
  border-right: none;
}
.border-sides-none {
  border-left: none;
  border-right: none;
}
.border-none {
  border: none;
}
</style>

<style>
#app.html-header{
  /* all: initial; */
  /* text-align:  */
  /* all: initial; */
  /* font: inherit; */
  /* align-content: unset; */
  /* width: 100%; */
}

</style>